<mat-icon *ngIf="show"
          class="ml-0.5 icon-size-6 text-orange-600"
          [svgIcon]="'mat_solid:update'"
          [matTooltip]="'Pending: The new value hasn\'t been updated on the device twin yet'">
</mat-icon>
